import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from "vue";
import BonusomatProgress from "../shared/bonusomat-progress.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-board-task',
  props: {
    name: {},
    icon: {},
    repeatable: { type: Boolean },
    completed: { type: Boolean },
    progress: {},
    isActive: { type: Boolean },
    progressLoadCounter: {},
    progressAlwaysVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const title = computed(() => props.name?.replace("-", "&#x2011;"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["board-task", {
            'board-task--in-progress': _ctx.progress > 0 && !_ctx.completed,
            'board-task--active': _ctx.isActive,
            'board-task--done': _ctx.completed,
        }])
  }, [
    (_openBlock(), _createBlock(BonusomatProgress, {
      key: _ctx.progressLoadCounter,
      progress: _ctx.progress,
      "always-visible": _ctx.progressAlwaysVisible,
      "is-completed": _ctx.completed && _ctx.progress == 100,
      "show-percentage-number": ""
    }, null, 8, ["progress", "always-visible", "is-completed"])),
    (_ctx.repeatable)
      ? (_openBlock(), _createBlock(DsIcon, {
          key: 0,
          name: "rotate",
          class: "board-task__rotate"
        }))
      : _createCommentVNode("", true),
    (_ctx.icon && _ctx.name)
      ? (_openBlock(), _createBlock(WebpImage, {
          key: 1,
          src: _ctx.icon,
          alt: _ctx.name,
          "css-class": "board-task__img"
        }, null, 8, ["src", "alt"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "board-task__title",
      innerHTML: title.value
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})